import { createStandardAction } from 'typesafe-actions';
import { UserSession } from '../../Models';

const AUTH_SIGN_UP = 'AUTH_SIGN_UP';
const AUTH_SIGN_UP_SUCCESS = 'AUTH_SIGN_UP_SUCCESS';
const AUTH_SIGN_UP_ERROR = 'AUTH_SIGN_UP_ERROR';

const AUTH_SIGN_UP_FORM_SUBMIT = 'AUTH_SIGN_UP_FORM_SUBMIT';

const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
const AUTH_SIGN_IN_ERROR = 'AUTH_SIGN_IN_ERROR';

const AUTH_SIGN_IN_FORM_SUBMIT = 'AUTH_SIGN_IN_FORM_SUBMIT';

const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
const AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS';
const AUTH_RESET_PASSWORD_ERROR = 'AUTH_RESET_PASSWORD_ERROR';

const AUTH_RESET_PASSWORD_FORM_SUBMIT = 'AUTH_RESET_PASSWORD_FORM_SUBMIT';

const AUTH_SET_GLOBAL_FORM_ERRORS = 'AUTH_SET_GLOBAL_FORM_ERRORS';
const AUTH_CLEAR_GLOBAL_FORM_ERRORS = 'AUTH_CLEAR_GLOBAL_FORM_ERRORS';

export const authSignUp = createStandardAction(AUTH_SIGN_UP)<any>();
export const authSignUpSuccess = createStandardAction(AUTH_SIGN_UP_SUCCESS)<UserSession>();
export const authSignUpError = createStandardAction(AUTH_SIGN_UP_ERROR)();

export const authSubmitSignUpForm = createStandardAction(AUTH_SIGN_UP_FORM_SUBMIT)();

export const authSignIn = createStandardAction(AUTH_SIGN_IN)<any>();
export const authSignInSuccess = createStandardAction(AUTH_SIGN_IN_SUCCESS)<UserSession>();
export const authSignInError = createStandardAction(AUTH_SIGN_IN_ERROR)();

export const authSubmitSignInForm = createStandardAction(AUTH_SIGN_IN_FORM_SUBMIT)();

export const authResetPassword = createStandardAction(AUTH_RESET_PASSWORD)<any>();
export const authResetPasswordSuccess = createStandardAction(AUTH_RESET_PASSWORD_SUCCESS)();
export const authResetPasswordError = createStandardAction(AUTH_RESET_PASSWORD_ERROR)();

export const authSubmitResetPasswordForm = createStandardAction(AUTH_RESET_PASSWORD_FORM_SUBMIT)<{
  successToastMessage: any;
}>();

export const authSetGlobalFormErrors = createStandardAction(AUTH_SET_GLOBAL_FORM_ERRORS)<any>();
export const authClearGlobalFormErrors = createStandardAction(AUTH_CLEAR_GLOBAL_FORM_ERRORS)<any>();



// WEBPACK FOOTER //
// ./src/containers/Auth/actions.ts